<div class="w-full p-4 sm:p-6 space-y-6">

    <ng-container *ngFor="let item of destination.ar_props; index as i">

        <mat-card [class.mat-card-disabled]="reviewMode">
            <mat-card-header>
                <mat-card-title>{{ item.ds_label_destinationprop }}</mat-card-title>
                <mat-card-subtitle *ngIf="!isSingleSelect(item)">
                    Select between {{item.vi_min_destinationpropdtype}} and {{item.vi_max_destinationpropdtype}} options.
                </mat-card-subtitle>
                <mat-card-subtitle *ngIf="isSingleSelect(item)">
                    Select one option.
                </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
                <div *ngIf="isSingleSelect(item); else multiSelectBlock" class="flex flex-col">
                    <mat-radio-group
                        class="flex flex-col space-y-2"
                        (change)="onRadioGroupChange($event, item.ar_items)">
                        <mat-radio-button
                            *ngFor="let prop of item.ar_items"
                            [value]="prop"
                            [checked]="prop.bl_Active"
                            [disabled]="reviewMode"
                            color="primary">
                            {{ prop.ds_label_destinationpropoption }}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>

                <ng-template #multiSelectBlock>
                    <div class="flex flex-col space-y-2">
                        <mat-checkbox
                            *ngFor="let prop of item.ar_items"
                            [checked]="prop.bl_Active"
                            [disabled]="reviewMode || (countSelectedProps(item) >= item.vi_max_destinationpropdtype && !prop.bl_Active)"
                            color="primary"
                            (change)="featuresAutosave(prop)">
                            {{ prop.ds_label_destinationpropoption }}
                        </mat-checkbox>
                    </div>
                </ng-template>

                <fuse-alert
                    class="mt-6"
                    *ngIf="alertToggle(item) && !reviewMode"
                    [appearance]="'outline'"
                    [showIcon]="true"
                    [type]="'error'">
                    Please select at least {{ item.vi_min_destinationpropdtype }} and at most {{ item.vi_max_destinationpropdtype }} options.
                </fuse-alert>

            </mat-card-content>
        </mat-card>

    </ng-container>

</div>
